import { IDirective, INgModelController } from 'angular';
import { isPhoneValid } from '../../../helpers/validators';

export function gmcPhoneValidatorDirective(): IDirective {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function postLink( scope, element, attrs, ngModel: INgModelController ) {
      if ( scope.$eval(attrs.gmcPhoneValidator) === true ) {
        ngModel.$validators.tel = ( modelValue, viewValue ): boolean => {
          const value = modelValue || viewValue;
          return !value ? true : isPhoneValid(value);
        };
        element.on('input', ( event: any ) => {
          let value = event.target.value;
          const firstChar = value.slice(0, 1).replace(/[^0-9+]/g, '');
          const otherChars = value.slice(1).replace(/[^0-9]/g, '');
          value = firstChar + otherChars;
          ngModel.$setViewValue(value);
          ngModel.$render();
        });
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/directives/validator-directives/gmc-phone-validator.directive.ts